import { Pipe, PipeTransform } from '@angular/core';

const PAYMENT_LOGO_MAP = [
  'amex-color.svg',
  'amex-fill.svg',
  'amex-outline.svg',
  'applepay-color.svg',
  'applepay-fill.svg',
  'applepay-outline.svg',
  'card-default-color.svg',
  'card-default-fill.svg',
  'card-default-outline.svg',
  'cash-color.svg',
  'cash-dollar-color.svg',
  'cash-dollar-fill.svg',
  'cash-dollar-outline.svg',
  'cash-fill.svg',
  'cash-outline.svg',
  'discover-color.svg',
  'discover-fill.svg',
  'discover-outline.svg',
  'mastercard-color.svg',
  'mastercard-fill.svg',
  'mastercard-outline.svg',
  'paypal-color.svg',
  'paypal-fill.svg',
  'paypal-outline.svg',
  'visa-color.svg',
  'visa-fill.svg',
  'visa-outline.svg',
];

@Pipe({
  name: 'paymentLogo',
  standalone: false,
})
export class PaymentLogoPipe implements PipeTransform {
  transform(value: string, theme: 'dark' | 'light' = 'dark'): unknown {
    if (
      PAYMENT_LOGO_MAP.includes(`${value.toLowerCase()}-${this.cv(theme)}.svg`)
    ) {
      return `/assets/img/cards/${value.toLowerCase()}-${this.cv(theme)}.svg`;
    }
    return `/assets/img/cards/card-default-${this.cv(theme)}.svg`;
  }

  private cv(theme: 'dark' | 'light' = 'dark') {
    return theme === 'dark' ? 'color' : 'outline';
  }
}
